import gql from 'graphql-tag';
export const CASH_COLLECTOION_DATA = gql`
  query cashCollection($first: Int!, $page: Int!) {
    cashCollection(first: $first, page: $page) {
      paginatorInfo {
        count
        total
        __typename
      }
      data {
        id
        amount
        created_at
        printed_at
        shift_id
        user {
          id
          name
          phone
        }
        driver {
          id
          name
          phone
        }
        station {
          id
          name_en
        }
        shift {
          id
          shift_log {
            id
            shift {
              id
              name
              code
            }
          }
        }
      }
    }
  }
`;
export default CASH_COLLECTOION_DATA;
